import React, { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../styles/Home.module.css";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import mapData from "../components/data/mapData";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
} from "@material-ui/core";
import GroupIcon from "@material-ui/icons/Group";
import HomeIcon from "@material-ui/icons/Home";
import addTreemapModule from "highcharts/modules/treemap";
import axios from "axios";
import convertISOStringToMonthDay from "../services/convertDate";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  withRouter,
  Link,
} from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../libs/utils/axiosApiInstance";

require("highcharts/modules/map")(Highcharts);
addTreemapModule(Highcharts);

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  Card: {
    minWidth: 275,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  largeIcon: {
    width: 1000,
    height: 60,
  },
  buttonConfirm: {
    background: "#FDB738",
    fontSize: "1.0rem",
    width: "100%",
    height: "45px",
  },
  bannerRow: {
    background: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0)), url('images/P-1.png')`,
    backgroundRepeat: "no-repeat",
    // height: '55vh',
    // position: 'absolute',
    backgroundSize: "cover",
    backgroundPosition: "bottom",
    // zIndex: -1,
    width: "100%",
  },
}));

Highcharts.setOptions({
  lang: {
    thousandsSep: ",",
  },
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.MuiTableCell-head`]: {
    fontSize: 18,
    color: "#fff",
    backgroundColor: "#4472c4",
  },
  [`&.MuiTableCell-body`]: {
    fontSize: 16,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: "#ffffffde",
  "&:nth-of-type(odd)": {
    backgroundColor: "#e1e1e1e3",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function Home() {
  const classes = useStyles();

  const [promotion, setPromotion] = useState([]);
  const [readyToSellItems, setReadyToSellItems] = useState([]);
  const [branchs, setBranchs] = React.useState([]);
  const [CatalogNo, setCatalogNo] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [loadingPDF, setLoadingPDF] = React.useState(false);
  const [base_api, setPathUrl] = useState()

  useEffect(() => {
    const init = async () => {
      const response = await fetch("/resources/config.json");
      const results = await response.json();
      setPathUrl(results);
    };
    init();
  }, []);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const LoadPromotion = async () => {
    try {
      const res = await api.get(`/dashboard/front/promotions`);
      const _promotion = res.data.result;
      setPromotion(_promotion);
    } catch (err) {
      console.log(err);
    }
  };

  const LoadReadyToSellItems = async () => {
    try {
      const res = await api.get(`dashboard/front/ready-to-sell-items`);
      const data = res.data.result;
      setReadyToSellItems(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    LoadPromotion();
    LoadReadyToSellItems();
  }, []);

  const linkToPerm = () => {
    window.open("https://newwebs2.ricethailand.go.th/webmain/rkb3/");
  };

  return (
    <>
      <Box
        className="container-fluid"
        sx={{
          maxWidth: { lg: "1450px !important", xs: "1200px" },
          margin: "0px auto",
        }}
      >
        <div className="row">
          {promotion.length > 0 && (
            <div className="col-xs-12">
              <div
                className={styles.carddashboard}
                style={{ textAlign: "center", background: "#4472C4" }}
              >
                <div className="row">
                  <div className="col-12 text-center">
                    <Typography
                      variant="h4"
                      style={{
                        marginBottom: "15px",
                        color: "#fff",
                      }}
                    >
                      โปรโมชั่นลดราคา
                    </Typography>
                  </div>
                </div>
                <div
                  className="col-12"
                  style={{
                    // height: '45.5vh',
                    // overflow: 'auto',
                    // position: 'relative'
                    position: "relative",
                    backgroundImage: `url("/imageedit_1_4738527356.png")`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "20%",
                    backgroundColor: "#fff",
                  }}
                >
                  <Promotion />
                </div>
              </div>
            </div>
          )}
          <div className="col-xs-12 text-center mt-5 mb-5">
            <div
              className={styles.carddashboard}
              style={{ textAlign: "center", background: "#4472C4" }}
            >
              <h2 style={{ color: "#fff" }}>เมล็ดพันธุ์ข้าวพร้อมจำหน่าย</h2>
              <div
                style={{
                  // height: '45.5vh',
                  // overflow: 'auto',
                  position: "relative",
                  backgroundImage: `url("/imageedit_1_4738527356.png")`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20%",
                  backgroundColor: "#fff",
                }}
              >
                <TableContainer
                  style={{ height: "800px", border: "5px solid #fff" }}
                >
                  <Table
                    stickyHeader
                    style={{
                      width: "100%",
                    }}
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow>
                        <StyledTableCell
                          align="center"
                          style={{ width: "20%" }}
                        >
                          พันธุ์
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ width: "15%" }}
                        >
                          ปริมาณ (กิโลกรัม)
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ width: "50%" }}
                        >
                          ศูนย์เมล็ดพันธุ์ข้าว
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ width: "15%" }}
                        >
                          ดำเนินการ
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {readyToSellItems.length > 0 &&
                        readyToSellItems?.map((item, i) => {
                          return (
                            <StyledTableRow
                              key={i}
                              style={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <StyledTableCell align="center">
                                {item?.CatalogName}
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                {item?.Balance?.toLocaleString()}
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                {item?.Branchs?.map((y) => y?.BranchName)?.join(
                                  ", ",
                                )}
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={() => {
                                    setOpen(true);
                                    setBranchs(item?.Branchs);
                                    setCatalogNo(item?.CatalogNo);
                                  }}
                                >
                                  เรียกดู
                                </Button>
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>

          <div className="col-md-5 col-xs-12  text-center">
            <div
              className={styles.carddashboard}
              style={{ textAlign: "center", background: "#4472C4" }}
            >
              <h5 style={{ color: "#fff" }}>
                ราคาจำหน่ายเมล็ดพันธุ์ข้าว (บาท/กิโลกรัม)
              </h5>

              <div
                className="col-12"
                style={{
                  // height: '41.5vh',
                  // overflow: 'auto',
                  // position: 'relative'
                  backgroundImage: `url("/imageedit_1_4738527356.png")`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "35%",
                  backgroundColor: "#fff",
                }}
              >
                <ItemPrice />
              </div>
            </div>

            <div className="border border-secondary rounded-4 mt-5 mb-5 p-4">
              <h4>เงื่อนไขการจำหน่าย</h4>
              <div className="text-start">
                {/* <p>
                  ราคาส่วนลด<br></br>
                  ลูกค้าทุกประเภท ที่มีการสั่งซื้อเมล็ดพันธุ์ข้าว ตั้งแต่ 5,000
                  บาทขึ้นไป ต่อ 1 ใบเสร็จรับเงิน จะได้รับส่วนลดร้อยละ 5
                  ของยอดสั่งซื้อ (ยกเว้นกรณีชำระเป็นเงินเชื่อ)
                </p> */}
                <Box
                  component="div"
                  dangerouslySetInnerHTML={{
                    __html: base_api?.TERMS_SALE?.replace(/\n/g, "<br />"),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-7 col-xs-12">
            <div className="row">
              <div className="col-md-6 col-xs-12">
                <div className={styles.carddashboard}>
                  <AgentAndBranch />
                </div>
              </div>
              <div className="col-md-6 col-xs-12">
                <div
                  className={styles.carddashboard}
                  onClick={linkToPerm}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="row"
                    style={{
                      height: " 166px",
                      // display: 'flex',
                      // alignItems: 'center',
                      // textAlign: 'center'
                    }}
                  >
                    <div
                      class="bounding-box"
                      className={classes.bannerRow}
                    ></div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xs-12">
                <div className={styles.carddashboard}>
                  <StatisticSale />
                </div>
              </div>
              <div className="col-md-6 col-xs-12">
                <VisitStat />
              </div>
            </div>
          </div>
        </div>
      </Box>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <div className="row">
            <div className="col-xs-12 text-center">
              <h2>เมล็ดพันธุ์ข้าวพร้อมจำหน่าย</h2>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
                className="mt-3 mb-3"
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/* <FormControl variant='filled' size='small' className={classes.formControl}>
                    <InputLabel id="demo-simple-select-label">ชนิดข้าว</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="ชนิดข้าว"
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl variant='filled' size='small' className={classes.formControl}>
                    <InputLabel id="demo-simple-select-label">พันธุ์ข้าว</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="พันธุ์ข้าว"
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl variant='filled' size='small' className={classes.formControl} style={{ width: '100px' }}>
                    <InputLabel id="demo-simple-select-label">ฤดู</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="ฤดู"
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl variant='filled' size='small' className={classes.formControl} style={{ width: '100px' }}>
                    <InputLabel id="demo-simple-select-label">ปี</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="ปี"
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl variant='filled' size='small' className={classes.formControl} style={{ width: '200px' }}>
                    <InputLabel id="demo-simple-select-label">ศูนย์เมล็ดพันธุ์ข้าว</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="ศูนย์เมล็ดพันธุ์ข้าว"
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl> */}
                  {/* <Button variant='contained' style={{ fontSize: "18px" }} onClick={() => {
                    async function download() {
                      setLoadingPDF(true)
                      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/dashboard/front/ready-to-sell-items/pdf?catalogNo=${CatalogNo}`, {
                        responseType: 'arraybuffer'
                      })
                      const buffer = res.data
                      const blob = new Blob([buffer], { type: 'application/pdf' });
                      const url = window.URL.createObjectURL(blob);
                      window.open(url, '_blank');
                      setLoadingPDF(false)
                    }
                    download()
                  }} className={classes.formControl} color='primary' disabled={loadingPDF}>{loadingPDF ? <CircularProgress size={'26px'} color="inherit" /> : 'ดาวน์โหลด'}</Button>
                   */}
                </div>
              </div>
              <div
                style={{
                  position: "relative",
                  backgroundImage: `url("/imageedit_1_4738527356.png")`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "20%",
                  backgroundColor: "#fff",
                }}
              >
                <TableContainer
                  style={{
                    maxHeight: "60.5vh",
                  }}
                >
                  <Table
                    stickyHeader
                    style={{
                      width: "100%",
                    }}
                    aria-label="simple table"
                  >
                    <TableHead>
                      <TableRow>
                        {/* <StyledTableCell align="center">ชนิดข้าว</StyledTableCell> */}
                        <StyledTableCell align="center">
                          ประเภทข้าว
                        </StyledTableCell>
                        <StyledTableCell align="center">พันธุ์</StyledTableCell>
                        <StyledTableCell align="center">
                          ปริมาณ (กิโลกรัม)
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          ศูนย์เมล็ดพันธุ์ข้าว
                        </StyledTableCell>
                        <StyledTableCell align="center">ติดต่อ</StyledTableCell>
                        <StyledTableCell align="center"></StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {branchs?.map((item, i) => {
                        return (
                          <StyledTableRow
                            style={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            {/* <TableCell align="center">{item?.TypeName}</TableCell> */}
                            <StyledTableCell align="center">
                              {item?.GroupName}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {item?.CatalogName}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {item?.Balance?.toLocaleString()}
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              style={{ fontSize: "24px" }}
                            >
                              {item?.BranchName}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {item?.Tel}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              <Button
                                disabled={!item?.Latitude && !item?.Longitude}
                                onClick={() =>
                                  window.open(
                                    `https://www.google.com/maps/search/?api=1&query=${item?.Latitude},${item?.Longitude}`,
                                    "_blank",
                                  )
                                }
                                variant="contained"
                                color="secondary"
                              >
                                เเผนที่
                              </Button>
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}

                      <StyledTableRow
                        style={{
                          left: 0,
                          bottom: 0, // <-- KEY
                          zIndex: 2,
                          position: "sticky",
                          background: "#fff",
                        }}
                      >
                        <StyledTableCell colSpan={1}></StyledTableCell>
                        <StyledTableCell colSpan={1} align="center">
                          รวม {branchs[0]?.CatalogName}
                        </StyledTableCell>
                        <StyledTableCell colSpan={1} align="center">
                          {branchs
                            ?.map((x) => x?.Balance)
                            .reduce((accumulator, currentValue) => {
                              return accumulator + currentValue;
                            }, 0)
                            ?.toLocaleString()}
                        </StyledTableCell>
                        <StyledTableCell colSpan={1}></StyledTableCell>
                        <StyledTableCell colSpan={1}></StyledTableCell>
                        <StyledTableCell colSpan={1}></StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

class Dashboard1 extends React.Component {
  constructor(props) {
    super(props);
    this.linkToWeb = this.linkToWeb.bind(this);
    this.state = {
      dataApi: [],
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        series: {
          events: {
            click: (event) => this.linkToWeb(event),
          },
        },
      },
      colorAxis: {
        min: 0,

        stops: [
          [0, "red"],
          [0.67, "yellow"],
          [1, "green"],
        ],
      },
      tooltip: {
        pointFormat: " {point.name}: {point.value} ตัน<br /> ",
      },
      series: [],
    };
  }

  async componentDidMount() {
    await this.LoadData();
  }

  async linkToWeb(event) {
    const res = await api.get(`/dashboard/front/stock-by-branch`);
    const data = res.data.result;
    const link = [];
    for (const c of data) {
      link.push({
        key: c[0],
        link_name: c[3],
      });
    }

    const p = event.point.options;
    const o = Object.values(p);
    const Province_key = o[0];
    const find = link.find((x) => x.key === Province_key);
    if (find) {
      window.open(`${find.link_name}`);
    }
    // console.log(find);
    // let data_api = this.state.dataApi;
    // console.log(data_api);
    // data_api.forEach(x => {
    //   const i = Object.values(x);

    //   if(i.length === 2) {

    //   }

    // })
  }

  async LoadData() {
    try {
      const res = await api.get(`/dashboard/front/stock-by-branch`);
      // console.log(res.data.result);
      const dataApi = res.data.result;
      const stock = res.data.result;

      for (let i = 0; i < stock.length; i++) {
        stock[i][1] = stock[i][1] / 1000;
      }

      this.setState({
        dataApi: dataApi,
        series: {
          mapData: mapData,
          dataLabels: {},
          name: "ประเทศไทย",
          data: stock,
        },
      });
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    return (
      <div>
        <MapChart options={this.state} highcharts={Highcharts} />
      </div>
    );
  }
}

class StockByItemType extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stock: [],
    };
  }

  async componentDidMount() {
    await this.LoadData();
  }

  async LoadData() {
    try {
      const res = await api.get(`/dashboard/front/stock-by-item-type`);
      const stock = res.data.result;
      this.setState({
        stock: stock,
      });
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    return (
      <table className="table table-bordered">
        <thead>
          <tr
            style={{
              background: "#4472c4",
              color: "white",
              position: "sticky",
              top: 0,
              zIndex: 10,
            }}
          >
            <th scope="col" className="text-center">
              ชนิด/พันธุ์
            </th>
            {/* <th scope="col" className="text-center">หลัก (ตัน)</th> */}
            <th scope="col" className="text-center">
              ชั้นพันธุ์ขยาย (กิโลกรัม)
            </th>
            <th scope="col" className="text-center">
              ชั้นพันธุ์จำหน่าย (กิโลกรัม)
            </th>
          </tr>
        </thead>
        <tbody>
          {this.state.stock.map((v, index) => {
            return (
              <React.Fragment>
                {/* <tr style={{
                  background: '#cfd5ea'
                }} key={index}>
                  <td colspan="4">+ {v.TypeName} (ขยาย {v.Prices.Class1} บาท/กก. จำหน่าย {v.Prices.Class2} บาท/กก.)</td>
                </tr> */}
                {v.Catalogs.map((catalog, ic) => {
                  return (
                    <tr
                      key={ic}
                      style={{
                        background: "rgb(233, 235, 245)",
                      }}
                    >
                      <td>{catalog.CatalogName}</td>
                      {/* <td>{catalog.Balance.Class0 > 0 ? catalog.Balance.Class0.toLocaleString() : '-'}</td> */}
                      <td>
                        {catalog.Balance.Class1 > 0
                          ? catalog.Balance.Class1.toLocaleString()
                          : "-"}
                      </td>
                      <td>
                        {catalog.Balance.Class2 > 0
                          ? catalog.Balance.Class2.toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    );
  }
}

class ItemPrice extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      itemPrices: [],
    };
  }

  async componentDidMount() {
    await this.LoadData();
  }

  async LoadData() {
    try {
      const res = await api.get(`/dashboard/front/item-prices`);
      const itemPrices = res.data.result;
      this.setState({
        itemPrices: itemPrices,
      });
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    return (
      <TableContainer
        style={{
          height: "41.5vh",
          border: "5px solid #fff",
        }}
      >
        <Table stickyHeader style={{ width: "100%" }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">พันธุ์ข้าว</StyledTableCell>
              <StyledTableCell align="center">ชั้นพันธุ์ขยาย</StyledTableCell>
              <StyledTableCell align="center">
                ชั้นพันธุ์จำหน่าย
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.itemPrices.map((v, index) => {
              return (
                <StyledTableRow
                  style={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{v.CatalogName}</TableCell>
                  <TableCell align="center">{v.Class1Price}</TableCell>
                  <TableCell align="center">{v.Class2Price}</TableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      // <table className="table table-bordered">
      //   <thead>
      //     <tr style={{
      //       background: '#4472c4',
      //       color: 'white',
      //       position: 'sticky',
      //       top: 0,
      //       zIndex: 10
      //     }}>
      //       <th scope="col" className="text-center">พันธุ์ข้าว</th>
      //       {/* <th scope="col" className="text-center">ชั้นพันธุ์หลัก</th> */}
      //       <th scope="col" className="text-center">ชั้นพันธุ์ขยาย</th>
      //       <th scope="col" className="text-center">ชั้นพันธุ์จำหน่าย</th>
      //     </tr>
      //   </thead>
      //   <tbody>

      //     {this.state.itemPrices.map((v, index) => {

      //       return (
      //         <tr style={{
      //           background: '#e9ebf5'
      //         }} key={index}>
      //           <td className="text-center">{v.CatalogName}</td>
      //           {/* <td className="text-center">{v.Class0Price}</td> */}
      //           <td className="text-center">{v.Class1Price}</td>
      //           <td className="text-center">{v.Class2Price}</td>
      //         </tr>
      //       )
      //     })}
      //   </tbody>
      // </table>
    );
  }
}

class Promotion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      promotion: [],
    };
  }

  async componentDidMount() {
    await this.LoadData();
  }

  async LoadData() {
    try {
      const res = await api.get(`/dashboard/front/promotions`);
      let _promotion = res.data.result;
      _promotion.forEach((x) => {
        x.Balance = parseInt(x.Balance);
      });
      this.setState({
        promotion: _promotion,
      });
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    return (
      <TableContainer style={{ height: "350px", border: "5px solid #fff" }}>
        <Table stickyHeader style={{ width: "100%" }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">พันธุ์</StyledTableCell>
              <StyledTableCell align="center">ชั้นพันธุ์</StyledTableCell>
              <StyledTableCell align="center">ฤดู</StyledTableCell>
              <StyledTableCell align="center">ปี</StyledTableCell>
              <StyledTableCell align="center">
                ศูนย์เมล็ดพันธุ์ข้าว
              </StyledTableCell>
              <StyledTableCell align="center">
                ราคา (บาท/กิโลกรัม)
              </StyledTableCell>
              <StyledTableCell align="center">
                ปริมาณ (กิโลกรัม)
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.promotion.map((v, index) => {
              return (
                <StyledTableRow
                  style={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{v.CatalogName}</TableCell>
                  <TableCell align="center">{v.ClassName}</TableCell>
                  <TableCell align="center">{v.Season}</TableCell>
                  <TableCell align="center">{v.Year}</TableCell>
                  <TableCell align="center">{v.BranchName}</TableCell>
                  <TableCell align="center">
                    {parseFloat(v.PromotionPrice).toFixed(2)}
                  </TableCell>
                  <TableCell align="center">
                    {v.Balance > 0 ? v.Balance.toLocaleString() : "0"}
                  </TableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}

class AgentAndBranch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      totalBranch: 0,
      totalAgent: 0,
      openBranch: false,
      openAgent: false,
    };
  }

  async componentDidMount() {
    await this.LoadAgentCount();
    await this.LoadBranchCount();
  }

  async LoadAgentCount() {
    try {
      const res = await api.get(`/dashboard/front/agent-count`);
      const agentTotal = res.data.result;

      this.setState({
        totalAgent: agentTotal.AgentCount,
      });
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  async LoadBranchCount() {
    try {
      const res = await api.get(`/dashboard/front/branchs`);
      const branchs = res.data.result;
      this.setState({
        totalBranch: branchs.length,
      });
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col-12 text-center">
          <Typography
            style={{
              marginBottom: "15px",
              fontSize: "16px",
            }}
          >
            ค้นหาสถานที่จำหน่ายเมล็ดพันธุ์
          </Typography>
        </div>
        <div className="col-6 text-center">
          <Link
            to="/agents"
            style={{
              textDecoration: "none",
              color: "black",
            }}
          >
            <div>
              <GroupIcon
                style={{
                  fontSize: "4.4rem",
                  cursor: "pointer",
                }}
              ></GroupIcon>
            </div>
            <div>ตัวแทนจำหน่าย</div>
            <div>{this.state.totalAgent.toLocaleString()} ราย</div>
          </Link>
        </div>

        <div className="col-6 text-center">
          <Link
            to="/branchs"
            style={{
              textDecoration: "none",
              color: "black",
            }}
          >
            <div>
              <HomeIcon
                style={{
                  fontSize: "4.4rem",
                  cursor: "pointer",
                }}
              ></HomeIcon>
            </div>
            <div>ศูนย์เมล็ดพันธุ์ข้าว</div>
            <div>{this.state.totalBranch.toLocaleString()} ศูนย์</div>
          </Link>
        </div>
      </div>
    );
  }
}

class StatisticSale extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      staticSale: [],
    };
  }

  async componentDidMount() {
    await this.LoadData();
  }

  async LoadData() {
    try {
      const res = await api.get(
        `/dashboard/front/sale-statistic-by-customer-type`,
      );
      const staticSale = res.data.result;
      this.setState({
        staticSale: staticSale,
        datenow: convertISOStringToMonthDay(new Date()),
      });
      console.log(this.state.datenow);
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    return (
      <div className="row">
        <div className="col-12 text-center">
          <Typography
            variant="h6"
            style={{
              marginBottom: "15px",
            }}
          >
            สถิติการจำหน่าย
          </Typography>
        </div>
        <div
          style={{
            height: "31vh",
            overflow: "auto",
            position: "relative",
            display: "grid",
          }}
        >
          {this.state.staticSale.map((v, index) => {
            return (
              <div key={index} className="text-center">
                {v.CustomerType !==
                  "สมาคมผู้รวบรวมและจำหน่ายเมล็ดพันธุ์ข้าว" && (
                  <p>
                    {v.CustomerType} {v.SoldCount.toLocaleString()} ราย
                  </p>
                )}
              </div>
            );
          })}
          <div
            className=""
            style={{
              color: "gray",
              fontSize: "12px",
            }}
          >
            {this.state.datenow}
          </div>
        </div>
      </div>
    );
  }
}

class ReadySale extends React.Component {
  constructor(props) {
    super(props);
    this.openDialog = this.openDialog.bind(this);
    this.state = {
      dialog: {
        open: false,
        Catalogs: [],
        name: "",
      },
      title: {
        text: "เมล็ดพันธุ์ข้าวพร้อมจำหน่าย",
      },
      lang: {
        thousandsSep: ",",
      },
      credits: {
        enabled: false,
      },
      subtitle: {
        text: "หน่วย : ตัน",
        align: "left",
      },
      accessibility: {
        point: {
          valueSuffix: "%",
        },
      },
      tooltip: {
        outside: true,
        pointFormat: "{series.name}: <b>{point.y} ตัน</b> ",
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
          innerSize: 100,
          lang: {
            thousandsSep: ",",
          },
          dataLabels: {
            enabled: true,
            formatter: function () {
              return Highcharts.numberFormat(this.y, 2);
            },
            distance: -30,
            filter: {
              property: "percentage",
              operator: ">",
              value: 0,
            },
          },
        },
      },
      series: [],
    };
  }

  async componentDidMount() {
    await this.LoadData();
  }

  openDialog(event) {
    this.setState({
      dialog: {
        open: true,
        Catalogs: event.point.Catalogs,
        name: event.point.name,
      },
    });
  }

  async LoadData() {
    try {
      const res = await api.get(`/dashboard/front/stock-by-item-group`);
      let stock = res.data.result;
      let data = [];
      if (stock.length > 0) {
        stock.forEach((x) => {
          data.push({
            name: x.GroupName,
            y: x.Balance / 1000,
            Catalogs: x.Catalogs,
          });
        });
        this.setState({
          series: {
            name: "เมล็ดพันธุ์ข้าว",
            colorByPoint: true,
            type: "pie",
            events: {
              click: (event) => this.openDialog(event),
            },
            innerSize: "50%",
            data: data,
          },
        });
      }
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    const open = this.state.dialog.open;
    const Catalogs = this.state.dialog.Catalogs;
    const name = this.state.dialog.name;
    let dialog;
    if (open) {
      dialog = (
        <CatalogsListGroupDialog
          props={{
            dialog: open,
            Catalogs: Catalogs,
            name: name,
          }}
        />
      );
    } else {
      dialog = (
        <CatalogsListGroupDialog
          props={{
            dialog: open,
            Catalogs: Catalogs,
            name: name,
          }}
        />
      );
    }
    return (
      <div>
        {dialog}
        <PieChartReadySale options={this.state} highcharts={Highcharts} />
      </div>
    );
  }
}

class Dashboard2 extends React.Component {
  constructor(props) {
    super(props);
    this.openDialog = this.openDialog.bind(this);
    this.state = {
      dialog: {
        open: false,
        branchs: [],
        name: "",
      },
      credits: {
        enabled: false,
      },
      series: [],
      tooltip: {
        pointFormat: " {point.name}: {point.value} ตัน<br /> ",
      },
      plotOptions: {
        series: {
          events: {
            click: (event) => this.openDialog(event),
          },
        },
      },
      title: {
        text: null,
      },
    };
  }

  async componentDidMount() {
    await this.LoadData();
  }

  openDialog(event) {
    this.setState({
      dialog: {
        open: true,
        branchs: event.point.branchs,
        name: event.point.name,
      },
    });
  }

  async LoadData() {
    try {
      const res = await api.get(`/dashboard/front/stock-by-item-catalog`);
      let stock = res.data.result;
      const data = [];
      stock.forEach((x) => {
        data.push({
          name: x.CatalogName,
          value: x.Balance / 1000,
          color: "#" + Math.floor(Math.random() * 16777215).toString(16),
          branchs: x.Branchs,
        });
      });
      this.setState({
        series: [
          {
            type: "treemap",
            data: data,
            legendType: "point",
            showInLegend: true,
          },
        ],
      });
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    const open = this.state.dialog.open;
    const branchs = this.state.dialog.branchs;
    const name = this.state.dialog.name;
    let dialog;
    if (open) {
      dialog = (
        <BranchListGroupDialog
          props={{
            dialog: open,
            branchs: branchs,
            name: name,
          }}
        />
      );
    } else {
      dialog = (
        <BranchListGroupDialog
          props={{
            dialog: open,
            branchs: branchs,
            name: name,
          }}
        />
      );
    }
    return (
      <div>
        {dialog}
        <TreeChart options={this.state} highcharts={Highcharts} />
      </div>
    );
  }
}

function CatalogsListGroupDialog(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  useEffect(() => {
    setOpen(props.props.dialog);
  }, [props]);

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      {/* <Button onClick={handleClickOpen('paper')}>scroll=paper</Button>
      <Button onClick={handleClickOpen('body')}>scroll=body</Button> */}
      <Dialog
        maxWidth="xl"
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          รายการพันธุ์ข้าวที่มีพร้อมจำหน่าย{" "}
          <span
            style={{
              color: "red",
              fontWeight: "bold",
            }}
          >
            ({props.props.name})
          </span>
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <table className="table table-bordered">
              <thead>
                <tr
                  style={{
                    background: "#4472c4",
                    color: "white",
                  }}
                >
                  <th scope="col" className="text-center">
                    ที่
                  </th>
                  <th scope="col" className="text-center">
                    พันธุ์ข้าว
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.props.Catalogs.map((catalog, index) => (
                  <tr
                    style={{
                      background: "#e9ebf5",
                      verticalAlign: "middle",
                    }}
                    key={index}
                  >
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">{catalog.CatalogName}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            ปิด
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

function BranchListGroupDialog(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  useEffect(() => {
    setOpen(props.props.dialog);
  }, [props]);

  const handleClose = () => {
    setOpen(false);
  };

  const linkGoogleMap = (lat, long) => {
    if (!lat && !long) return;
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${lat},${long}`,
    );
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      {/* <Button onClick={handleClickOpen('paper')}>scroll=paper</Button>
      <Button onClick={handleClickOpen('body')}>scroll=body</Button> */}
      <Dialog
        maxWidth="xl"
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          รายการศูนย์เมล็ดพันธุ์ข้าวที่มีพร้อมจำหน่าย{" "}
          <span
            style={{
              color: "red",
              fontWeight: "bold",
            }}
          >
            {props.props.name}
          </span>
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            <table className="table table-bordered">
              <thead>
                <tr
                  style={{
                    background: "#4472c4",
                    color: "white",
                  }}
                >
                  <th scope="col" className="text-center">
                    ที่
                  </th>
                  <th scope="col" className="text-center">
                    ศูนย์เมล็ดพันธุ์ข้าว
                  </th>
                  <th scope="col" className="text-center">
                    ตำบล
                  </th>
                  <th scope="col" className="text-center">
                    อำเภอ
                  </th>
                  <th scope="col" className="text-center">
                    จังหวัด
                  </th>
                  <th scope="col" className="text-center">
                    ที่อยู่
                  </th>
                  <th scope="col" className="text-center">
                    เบอร์โทร
                  </th>
                  <th scope="col" className="text-center">
                    ที่ตั้ง
                  </th>
                </tr>
              </thead>
              <tbody>
                {props.props.branchs.map((branch, index) => (
                  <tr
                    style={{
                      background: "#e9ebf5",
                      verticalAlign: "middle",
                    }}
                    key={index}
                  >
                    <td className="text-center">{index + 1}</td>
                    <td className="text-center">{branch.BranchName}</td>
                    <td className="text-center">{branch.District}</td>
                    <td className="text-center">{branch.SubDistrict}</td>
                    <td className="text-center">{branch.Province}</td>
                    <td className="text-center">{branch.Address}</td>
                    <td className="text-center">{branch.Tel}</td>
                    <td>
                      <Button
                        variant="contained"
                        onClick={() =>
                          linkGoogleMap(branch.Latitude, branch.Longitude)
                        }
                        className={classes.buttonConfirm}
                        color="inherit"
                        style={{
                          fontSize: "14px",
                          color: "white",
                        }}
                      >
                        {" "}
                        แผนที่{" "}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            ปิด
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

function VisitStat() {
  const [stat, setStat] = useState({
    All: "0",
    Last_month: "0",
    Last_week: "0",
    This_month: "0",
    This_week: "0",
    Today: "0",
    Yesterday: "0",
  });

  const [ip, setIP] = useState("");
  const [nVer, setNver] = useState("");
  const [url, setUrl] = useState("");

  const getIP = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setIP(res.data.IPv4);
  };
  const init = async () => {
    const response = await fetch("/resources/config.json");
    const results = await response.json();
    setUrl(results?.REACT_APP_ADMIN_URL);
  };

  useEffect(() => {
    var nVer = navigator.appVersion;
    setNver(nVer);

    const fecthStats = async () => {
      const response = await api.get(`/visitors-stat`);

      const b = await response.data;
      const _stat = b.result;
      setStat(_stat);
    };

    fecthStats();
    getIP();
    init();
  }, []);
  return (
    <>
      <div
        className={styles.carddashboard}
        style={{
          // padding: '10px 10px 10px 25px',
          backgroundColor: "rgb(68, 114, 196)",
        }}
      >
        <div className="row">
          <div className=" text-left">
            <label
              style={{
                color: "#ffff",
                fontSize: "15px",
                paddingBottom: "4px",
              }}
            >
              จำนวนผู้เข้าชมเว็บไซต์
            </label>
          </div>
          <div
            style={{
              backgroundColor: "#ffff",
              borderRadius: "4px",
              padding: "4px 20px 10px 20px",
              minHeight: "27.5vh",
              overflow: "auto",
              position: "relative",
            }}
          >
            <div className="text-center">
              <label
                style={{
                  fontSize: "1.7rem",
                  backgroundColor: "black",
                  color: "#FDB738",
                  marginTop: "5px",
                  marginBottom: "5px",
                  letterSpacing: "4px",
                  padding: "4px",
                  borderRadius: "7px",
                }}
              >
                {stat.All}
              </label>
            </div>

            <div
              className="d-flex justify-content-between"
              style={{
                color: "gray",
                fontWeight: "bold",
              }}
            >
              <div>Today</div>
              <div>{stat.Today}</div>
            </div>
            <div
              className="d-flex justify-content-between"
              style={{
                color: "gray",
                fontWeight: "bold",
              }}
            >
              <div>Yesterday</div>
              <div>{stat.Yesterday}</div>
            </div>
            <div
              className="d-flex justify-content-between"
              style={{
                color: "gray",
                fontWeight: "bold",
              }}
            >
              <div>This week</div>
              <div>{stat.This_week}</div>
            </div>
            <div
              className="d-flex justify-content-between"
              style={{
                color: "gray",
                fontWeight: "bold",
              }}
            >
              <div>Last week</div>
              <div>{stat.Last_week}</div>
            </div>
            <div
              className="d-flex justify-content-between"
              style={{
                color: "gray",
                fontWeight: "bold",
              }}
            >
              <div>This month</div>
              <div>{stat.This_month}</div>
            </div>
            <div
              className="d-flex justify-content-between"
              style={{
                color: "gray",
                fontWeight: "bold",
              }}
            >
              <div>Last month</div>
              <div>{stat.Last_month}</div>
            </div>
            <div
              className="d-flex justify-content-between"
              style={{
                color: "gray",
                fontWeight: "bold",
              }}
            >
              <div>All</div>
              <div>{stat.All}</div>
            </div>
            <hr
              style={{
                color: "#000000",
                backgroundColor: "#000000",
                height: 0.5,
                borderColor: "#000000",
              }}
            />
            <div
              className="text-center"
              style={{
                opacity: 0.5,
              }}
            >
              <span>Your IP: {ip}</span>
            </div>
            <div
              className="text-center"
              style={{
                opacity: 0.5,
              }}
            >
              <span>{nVer}</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// export function ScrollDialog(props) {
//   console.log(props);
//   const [open, setOpen] = React.useState(props.open);
//   const [scroll, setScroll] = React.useState('paper');

//   const handleClickOpen = (scrollType) => () => {
//     setOpen(true);
//     setScroll(scrollType);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   useEffect(() => {

//     console.log(props);

// }, [props]);

//   const descriptionElementRef = React.useRef(null);
//   React.useEffect(() => {
//     if (open) {
//       const { current: descriptionElement } = descriptionElementRef;
//       if (descriptionElement !== null) {
//         descriptionElement.focus();
//       }
//     }
//   }, [open]);

//   return (
//     <div>
//       <Button onClick={handleClickOpen('paper')}>scroll=paper</Button>
//       <Button onClick={handleClickOpen('body')}>scroll=body</Button>

//     </div>
//   );
// }

class StaticSaleLineChartCom extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chart: {
        type: "column",
      },
      title: {
        text: "สถิติการจำหน่าย",
      },
      subtitle: {
        text: "หน่วย : กิโลกรัม",
        align: "left",
      },

      credits: {
        enabled: false,
      },
      xAxis: {
        title: {
          text: null,
        },
      },
      yAxis: {
        labels: {
          formatter: function () {
            return this.value.toLocaleString();
          },
        },
        min: 0,
        title: {
          text: null,
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [],
    };
  }

  async componentDidMount() {
    await this.LoadData();
  }

  async LoadData() {
    try {
      const res = await api.get(
        `/dashboard/front/sale-statistic-by-item-group`,
      );
      let stock = res.data.result;
      if (stock.length > 0) {
        const categories = [];
        const items = [];
        const soldout = [];
        stock.forEach((x) => {
          categories.push(x.GroupName);
          items.push(x.TotalQty);
          soldout.push(x.SoldQty);
        });

        this.setState({
          xAxis: {
            categories: categories,
            crosshair: true,
          },
          series: [
            {
              name: "เมล็ดพันธุ์ดี",
              data: items,
              color: "#4472c4",
            },
            {
              name: "จำหน่ายแล้ว",
              data: soldout,
              color: "#ed7d31",
            },
          ],
        });
      }
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    return (
      <div>
        <LineChartStaticSale options={this.state} highcharts={Highcharts} />
      </div>
    );
  }
}

class StaticDistributionLineChartCom extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chart: {
        type: "column",
      },
      title: {
        text: "ผลการจำหน่ายรายพันธุ์",
      },
      subtitle: {
        text: "หน่วย : กิโลกรัม",
        align: "left",
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        title: {
          text: null,
        },
      },
      yAxis: {
        labels: {
          formatter: function () {
            return this.value.toLocaleString();
          },
        },
        min: 0,
        title: {
          text: null,
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y}</b></td></tr>',
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [],
    };
  }

  async componentDidMount() {
    await this.LoadData();
  }

  async LoadData() {
    try {
      const res = await api.get(
        `/dashboard/front/sale-statistic-by-item-catalog`,
      );
      let stock = res.data.result;
      if (stock.length > 0) {
        const categories = [];
        const items = [];
        const soldout = [];
        stock.forEach((x) => {
          categories.push(x.CatalogName);
          items.push(x.TotalQty);
          soldout.push(x.SoldQty);
        });

        this.setState({
          xAxis: {
            categories: categories,
            crosshair: true,
          },
          series: [
            {
              name: "เมล็ดพันธุ์ดี",
              data: items,
              color: "#4472c4",
            },
            {
              name: "จำหน่ายแล้ว",
              data: soldout,
              color: "#ed7d31",
            },
          ],
        });
      }
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  }

  render() {
    return (
      <div>
        <LineChartStaticDistribution
          options={this.state}
          highcharts={Highcharts}
        />
      </div>
    );
  }
}

const MapChart = ({ options, highcharts }) => (
  <HighchartsReact
    highcharts={highcharts}
    constructorType={"mapChart"}
    options={options}
  />
);

const TreeChart = ({ options, highcharts }) => (
  <HighchartsReact highcharts={highcharts} options={options} />
);

const PieChartReadySale = ({ options, highcharts }) => (
  <HighchartsReact highcharts={highcharts} options={options} />
);

const LineChartStaticSale = ({ options, highcharts }) => (
  <HighchartsReact highcharts={highcharts} options={options} />
);

const LineChartStaticDistribution = ({ options, highcharts }) => (
  <HighchartsReact highcharts={highcharts} options={options} />
);
